import React from 'react'
//import {Route} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../../config.js'

import {setRedirectUrl, fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'
import Header from './CoreRouteHeader.js'
import i18n_texts from '../../i18n.js';


class CoreRoute extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0};
  }

  componentDidMount() {
    if (!this.props.session_token) {
      this.props.setRedirectUrl(this.props.currentURL);
      this.props.redirectToLogin();
    }
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "plan", "GET", config.api_url+"/plan?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "plan", "GET", config.api_url+"/plan?t="+nextProps.session_token);
    }
  }

  render() {
    if(this.props.session_token) {
      return (
        <div>
          <Header i18n_texts={i18n_texts} app_language={this.props.app_language} />
          <main style={{paddingTop:"5em"}}>
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              app_language: this.props.app_language,
              i18n_texts
            })}
          </main>
        </div>
      );
    } else {
      return null
    }
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null, account_plan = "lite", app_language = "NL";
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["plan"] !== undefined && state.apiData["plan"]["data"]["name"] !== undefined) {
    account_plan = state.apiData["plan"]["data"]["name"];
    if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["email"] !== undefined && state.apiData["login"]["data"]["email"] === "hi@peter.plus") {
      account_plan = "premium";
    }
  }
  if(state.apiData["language"] !== undefined) {
    app_language = state.apiData["language"]["language"];
  }
  return {
    account_plan: account_plan,
    session_token: session_token,
    currentURL: ownProps.location.pathname,
    app_language: app_language
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    redirectToLogin: () => push('/start'),
    setRedirectUrl,
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRoute.js